import { Log, LogGroup } from ".././MyHelpers";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IContext } from "./IContext";
import { IChangeableInterval, IInterval, Interval } from "./Interval";
import { IRandomInterval, RandomInterval } from "./RandomInterval";
import { IRandomTimeout, RandomTimeout } from "./RandomTimeout";
import { ITimeout, Timeout, TimingCallback } from "./Timeout";

export interface ITimingContext extends IContext
{
    //CreateSubContext(resid: ResourceIdentifier, logGroup: LogGroup): ITimingContext;
    CreateTimeout(name: string, timeoutMillis: number, callback: TimingCallback): ITimeout;
    CreateRandomTimeout(name: string, timeoutFrom: number, timeoutTo: number, callback: TimingCallback): IRandomTimeout;

    CreateInterval(name: string, intervalMillis: number, callback: TimingCallback): IInterval;
    CreateChangeableInterval(name: string, intervalMillis: number, callback: TimingCallback): IChangeableInterval;
    CreateRandomInterval(name: string, intervalFrom: number, intervalTo: number, callback: TimingCallback): IRandomInterval;
}

export class TimingContext implements ITimingContext
{
    protected enabled: boolean = false;

    protected resid: ResourceIdentifier;
    protected logGroup: LogGroup;

    public constructor(resid: ResourceIdentifier, logGroup: LogGroup)
    {
        this.resid = resid;
        this.logGroup = logGroup;
    }

    protected timeouts: Timeout[] = [];
    public CreateTimeout(name: string, timeoutMillis: number, callback: TimingCallback) : ITimeout
    {
        let timeout: Timeout = new Timeout(this.resid.Add("Timeout").Add(name), callback, timeoutMillis);
        this.timeouts.push(timeout);

        return timeout;
    }

    protected randomTimeouts: RandomTimeout[] = [];
    public CreateRandomTimeout(name: string, timeoutFrom: number, timeoutTo: number, callback: TimingCallback) : IRandomTimeout
    {
        let randomTimeout: RandomTimeout = new RandomTimeout(this.resid.Add("Timeout").Add(name), callback, timeoutFrom, timeoutTo);
        this.randomTimeouts.push(randomTimeout);

        return randomTimeout;
    }

    protected CheckRunningTimeouts(): void
    {
        for (let i = 0; i < this.timeouts.length; i++)
        {
            if (this.timeouts[i].Running())
            {
                Log.Error(this.logGroup, "Stopping, but TIMEOUT " + this.timeouts[i].Name() + " is still running! Killing it");
                this.timeouts[i].Stop();
            }
        }
    }


    protected intervals: Interval[] = [];
    public CreateInterval(name: string, intervalMillis: number, callback: TimingCallback): IInterval
    {
        let interval: Interval = new Interval(this.resid.Add("Interval").Add(name), callback, intervalMillis);
        this.intervals.push(interval);

        return interval;
    }

    public CreateChangeableInterval(name: string, intervalMillis: number, callback: TimingCallback): IChangeableInterval
    {
        let interval: Interval = new Interval(this.resid.Add("ChangeableInterval").Add(name), callback, intervalMillis);
        this.intervals.push(interval);

        return interval;
    }

    protected randomIntervals: RandomInterval[] = [];
    public CreateRandomInterval(name: string, intervalFrom: number, intervalTo: number, callback: TimingCallback): IInterval
    {
        let randomInterval: RandomInterval = new RandomInterval(this.resid.Add("RandomInterval").Add(name), callback, intervalFrom, intervalTo);
        this.randomIntervals.push(randomInterval);

        return randomInterval;
    }

    protected CheckRunningIntervals(): void
    {
        for (let i = 0; i < this.intervals.length; i++)
        {
            if (this.intervals[i].Running())
            {
                Log.Error(this.logGroup, "Stopping, but " + this.intervals[i].Name() + " is still running! Killing it");
                this.intervals[i].Stop();
            }
        }

        for (let i = 0; i < this.randomIntervals.length; i++)
        {
            if (this.randomIntervals[i].Running())
            {
                Log.Error(this.logGroup, "Stopping, but " + this.randomIntervals[i].Name() + " is still running! Killing it");
                this.randomIntervals[i].Stop();
            }
        }
    }

    public Name(): string
    {
        return this.resid.ID();
    }

    public Enable(): void
    {
        if (!this.enabled)
        {
            this.enabled = true;
        }
    }

    public Disable(): void
    {
        if (this.enabled)
        {
            this.enabled = false;
            this.CheckRunningTimeouts();
            this.CheckRunningIntervals();
        }
    }

    public Running(): boolean
    {
        return this.enabled;
    }
}